<script>
import API from "src/core/Api";
import dayjs from "dayjs";
import Numbro from "numbro";
import {mapGetters} from "vuex";
import '@vueform/slider/themes/default.css';

import Box from '/src/modules/medico/views/fichas/Box.vue';

// Define the scoring key for GDS
const gdsScoringKey = {
  ask1: 'No',
  ask2: 'Sí',
  ask3: 'Sí', // Corrected based on standard GDS-15, original prompt had 'No'
  ask4: 'Sí',
  ask5: 'No',
  ask6: 'Sí',
  ask7: 'No',
  ask8: 'Sí',
  ask9: 'Sí', // Corrected based on standard GDS-15, original prompt had 'No'
  ask10: 'Sí',
  ask11: 'No',
  ask12: 'Sí',
  ask13: 'No',
  ask14: 'Sí',
  ask15: 'Sí'  // Corrected based on standard GDS-15, original prompt had 'No'
};

export default {
 data() {
        return {
        //data

        showAddRango:false,
        showEditionRango:false,
        editingRango: {
            id: 0,
            detail: {
                articulacion: '',
                movimiento: '',
                lado: 'Izquierdo',
                rango_activo: null,
                rango_pasivo: null,
                hallazgos: ''
            }
        },

        showAddSensacion:false,
        showEditionSensacion:false,

        showAddFuerzaM:false,
        showEditionFuerzaM:false,

        showAddPruebaEspecial: false,
        showEditionPruebaEspecial:false,

        fm_TotalScore:0,
        ib_TotalScore:0,
        lb_TotalScore:0,
        dp_TotalScore:0,
        historial_geriatrico:{
          nutricional: '',
          psiquiatrica: '',
          anamnesis: '',
        },

        formulario_mental:{
            orientacion:{
                orientacion_ask_1: {
                    ask: '¿El año en que estamos?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
                orientacion_ask_2: {
                    ask: '¿La estación del año?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
                orientacion_ask_3: {
                    ask: '¿La fecha de hoy?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
                orientacion_ask_4: {
                    ask: '¿El día de la semana?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
                orientacion_ask_5: {
                    ask: '¿El mes?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
        },
            ubicacion:{
                donde_estamos_ask1: {
                    ask: '¿Región, zona geográfica?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
                donde_estamos_ask2: {
                    ask: '¿Estado?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
                donde_estamos_ask3: {
                    ask: '¿Ciudad?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
                donde_estamos_ask4: {
                    ask: '¿Nombre o tipo de local en dónde estamo?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
                donde_estamos_ask5: {
                    ask: '¿Piso o plana?',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
        },
            registro:{
          test: {
                    ask: 'Nombrar 3 objetos en 3 segundos, con una pausa entre cada uno de ellos. Aplicar 1 punto a cada objeto que el paciente consiga nombrar. Repetir los objetos hasta que el paciente nombre los tres. Puntuar solo la primera tentativa.',
                    check:false,
                    score: 3,
                    detailValue: '',
                },
        },
            calculo:{
          test: {
                    ask: 'Hacer que el paciente reste 7 de 100 y continuar la operación con el valor obtenido (es decir, resta seriada de 7). Aplicar 1 punto a cada respuesta correcta. Interrumpir la prueba después de 5 respuestas correctas.',
                    check:false,
                    score: 5,
                    detailValue: '',
                },
        },
            memoria:{
          test: {
                    ask: 'Hacer que el paciente recuerde el nombre de los tres objetos presentados en la fase de registro. Aplicar 1 punto a cada objeto recordado.',
                    check:false,
                    score: 3,
                    detailValue: '',
                },
        },
            nombrar:{
          test: {
                    ask: 'Señalar un bolígrafo y un reloj. Aplicar un punto a cada objeto que el paciente consiga nombrar.',
                    check:false,
                    score: 2,
                    detailValue: '',
                },
        },
            repeticion:{
          test: {
                    ask: 'Anotar los términos repetidos por el paciente: no, si y más.',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
        },
            lectura:{
          test: {
                    ask: 'El paciente debe leer y obedecer la orden siguiente ofrecida por escrito: "cierre los ojos',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
        },
            comprension:{
          test: {
                    ask: 'El paciente debe hacer las 3 fases de una orden: \n1. Coger un papel con la mano derecha \n2. Doblar el papel por la mitad \n3. Colocarlo en el suelo.\nAplicar 1 punto para cada fase realizada.',
                    check:false,
                    score: 3,
                    detailValue: '',
                },
        },
            escritura:{
          test: {
                    ask: 'El paciente debe escribir una frase escogida por el mismo. Aplicar 1 punto a las frases a las frases que contengan sujeto y objeto, y que tengan sentido. Ignorar los errores de ortografía.',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
        },
            disenio:{
          test: {
                    ask: 'Amplíe el diseño que aparece abajo hasta que tenga 1 a 5 cm y solicite al paciente que lo copie. Aplicar 1 punto si todos los lados y ángulos aparecen representados y si los lados de intersección forman un cuadrado.',
                    check:false,
                    score: 1,
                    detailValue: '',
                },
        }
        },

        indice_barthel:{
            comer:{
                label:'Comer',
                type:'md',
                score:0,
                description1:'Dependiente',
                description2:'Necesita ayuda',
                description3:'Independiente'
            },
            lavarse:{
                label:'Lavarse',
                type:'md',
                score:0,
                description1:'Dependiente',
                description2:'Necesita ayuda',
                description3:'Independiente'
            },
            vestirse:{
                label:'Vestirse',
                type:'md',
                score:0,
                description1:'Dependiente',
                description2:'Necesita ayuda',
                description3:'Independiente'
            },
            aseo_personal:{
                label:'Aseo personal',
                type:'md',
                score:0,
                description1:'Dependiente',
                description2:'Necesita ayuda',
                description3:'Independiente'
            },
            deposicion:{
                label:'Deposición',
                type:'md',
                score:0,
                description1:'Incontinencia',
                description2:'Ocasionalmente algún episodio de incontinencia',
                description3:'Continencia normal'
            },
            miccion:{
                label:'Micción',
                type:'md',
                score:0,
                description1:'Incontinencia',
                description2:'Un episodio diario como máximo de incontinencia',
                description3:'Continencia normal'
            },
            uso_retrete:{
                label:'Uso del retrete',
                type:'md',
                score:0,
                description1:'Dependiente',
                description2:'Necesita ayuda',
                description3:'Independiente'
            },
            traslado:{
                label:'Traslado silla-cama',
                type:'lg',
                score:0,
                description1:'Dependiente',
                description2:'Necesita gran ayuda',
                description3:'Mínima ayuda física o supervisión',
                description4:'Independiente'
            },
            deambulacion:{
                label:'Deambulación',
                type:'lg',
                score:0,
                description1:'Dependiente',
                description2:'Necesita ayuda física o supervisión',
                description3:'Independiente en silla de ruedas',
                description4:'Independiente'
            },
            escaleras:{
                label:'Uso de escaleras',
                type:'md',
                score:0,
                description1:'Dependiente',
                description2:'Necesita ayuda física o supervisión',
                description3:'Independiente'
            }
        },

        lawton_brody:{
            cuidar_casa:{
                name:'Cuidar la casa',
                score:0,
                type:'select',
                options:[
                {  option:'Seleccione una opcion valida',
                value: 0,},
                {  option:'Cuida la casa sin ayuda',
                value: 1,},
                {  option:'Hace todo, menos el trabajo pesado',
                value: 2,},
                {  option:'Tareas ligeras unicamente',
                value: 3,},
                {  option:'Necesita ayuda para todas las tareas',
                value: 4,},
                {  option:'Incapaz de hacer nada',
                value: 5,}
                ]
            },
            lavado_ropa:{
                name:'Lavado de ropa',
                score:0,
                type:'select',
                options:[
                {  option:'Seleccione una opcion valida',
                value: 0,},
                {  option:'La realiza personalmente',
                value: 1,},
                {  option:'Solo lava pequeñas prendas',
                value: 2,},
                {  option:'Incapaz de lavar',
                value: 3,}
                ]
            },
            preparacion_comida:{
                name:'Preparación de la comida',
                score:0,
                type:'select',
                options:[
                {  option:'Seleccione una opcion valida',
                value: 0,},
                {  option:'Planea prepara y sirve sin ayuda',
                value: 1,},
                {  option:'Prepara si le dan los ingredientes',
                value: 2,},
                {  option:'Prepara platos precocinados',
                value: 3,},
                {  option:'Tienen que darle la comida hecha',
                value: 4,},
                ]
            },
            ir_compras:{
                name:'Ir de compras',
                score:0,
                type:'select',
                options:[
                {  option:'Seleccione una opcion valida',
                value: 0,},
                {  option:'Lo hace sin ninguna ayuda',
                value: 1,},
                {  option:'Sólo hace pequeñas compras',
                value: 2,},
                {  option:'Tienen que acompañarle',
                value: 3,},
                {  option:'Es incapaz de ir de compras',
                value: 4,},
                ]
            },
            uso_telefono:{
                name:'Uso del telefono',
                score:0,
                type:'select',
                options:[
                {  option:'Seleccione una opcion valida',
                value: 0,},
                {  option:'Capaz de utilizarlo sin problemas',
                value: 1,},
                {  option:'Sólo para lugares muy familiares',
                value: 2,},
                {  option:'Puede contestar pero no llamar',
                value: 3,},
                {  option:'Incapaz de utilizarlo',
                value: 4,},
                ]
            },
            uso_transporte:{
                name:'Uso del transporte',
                score:0,
                type:'select',
                options:[
                {  option:'Seleccione una opcion valida',
                value: 0,},
                {  option:'Viaja en transporte publico o conduce',
                value: 1,},
                {  option:'Sólo en taxi, no en autobús',
                value: 2,},
                {  option:'Necesita acompañamiento',
                value: 3,},
                {  option:'Incapaz de usarlo',
                value: 4,},
                ]
            },
            manejo_dinero:{
                name:'Manejo del dinero',
                score:0,
                type:'select',
                options:[
                {  option:'Seleccione una opcion valida',
                value: 0,},
                {  option:'LLeva cuentas, va a bancos, etc',
                value: 1,},
                {  option:'Sólo maneja cuentas sencillas',
                value: 2,},
                {  option:'Incapaz de utilizar dinero',
                value: 3,},
                ]
            },
            responsable_medicamentos:{
                name:'Responsable de medicamentos',
                score:0,
                type:'select',
                options:[{  option:'Seleccione una opcion valida',
                value: 0,},
                {  option:'Es responsable de su propia medicación',
                value: 1,},
                {  option:'Hay que prepararselos',
                value: 2,},
                {  option:'Incapaz de hacerlo por sí sólo',
                value: 3,},

                ]
            },
            comentarios:{
                type:'textarea',
                content: ''
            }
        },

        evaluacion_dolor:{
            primary_question:{
                localizacion_dolor:{
                    label: 'Localizacion del dolor',
                    value:'',
                    type: 'text'
                },
                tiempo:{
                    label: 'Hace cuanto tiempo',
                    value:'',
                    type: 'text'
                },
                irradiado:{
                    label: 'Irradiado',
                    value:'No',
                    options:[
                        { option: 'Si' , value:'Si'},
                        { option: 'No' , value:'No'}
                    ],
                    type: 'select'
                },
                zona:{
                    label: 'Zona del dolor',
                    value:'',
                    type: 'text'
                },
                tipo:{
                    label: 'Tipo de dolor',
                    value:'No select',
                    options:[
                        { option: 'No select' , value:'No select'},
                        { option: 'Superficial' , value:'Superficial'},
                        { option: 'Profundo' , value:'Profundo'}
                    ],
                    type: 'select'
                },
                duracion:{
                    label: 'Duración del dolor',
                    value:'',
                    type: 'text'
                },
                especificacion:{
                    label: 'Especificación del dolor',
                    value:'',
                    type: 'text'
                },
                fracuencia:{
                    label: 'Frecuencia del dolor',
                    value:'',
                    type: 'text'
                },
                movimientos_dolor:{
                    label: 'Movimiento y actividades que intensifican el dolor',
                    value:'',
                    type: 'text'
                },
                medicamentos_dolor:{
                    label: 'Medicamentos, movimientos y actividades que alivian el dolor',
                    value:'',
                    type: 'text'
                },
            },
            escala_visual_simple:{
                label:'Escala visual analógica (Simple)',
                value:'',
                options:[
                {option:'Sin dolor'},
                {option:'Dolor minimo'},
                {option:'Dolor moderado'},
                {option:'Dolor intenso'},
                {option:'Dolor muy intenso'},
                {option:'Peor dolor imaginable'}]
            },
            escala_visual_numerica:{
                label:'Escala visual analógica (Numérica)',
                value:'',
                options:[
                {option:'0'},
                {option:'1'},
                {option:'2'},
                {option:'3'},
                {option:'4'},
                {option:'5'},
                {option:'6'},
                {option:'7'},
                {option:'8'},
                {option:'9'},
                {option:'10'}
                ]
            },
            escala_visual_grafica:{
                label:'Escala visual grafica',
                value:'',
                options:[
                {option:'0' , icon:'fa-regular fa-face-grin-beam fa-2x'},
                {option:'1' , icon:'fa-regular fa-face-grin fa-2x'},
                {option:'2' , icon:'fa-regular fa-face-meh fa-2x'},
                {option:'3' , icon:'fa-regular fa-face-frown-open fa-2x'},
                {option:'4' , icon:'fa-regular fa-face-frown fa-2x'},
                {option:'5' , icon:'fa-regular fa-face-sad-cry fa-2x'},
            ]
            },
            comentarios:{
                value:''
            }
        },
        evaluacion_postural:{
            anterior:{
                label:'Vista anterior',
                value:''
            },
            posterior:{
                label:'Vista posterior',
                value:''
            },
            lateral_derecha:{
                label:'Vista lateral derecha',
                value:''
            },
            lateral_izquierda:{
                label:'Vista lateral izquierda',
                value:''
            },
            comentarios:{
                label:'Comentarios',
                value:''
            }
        },
        depre_geriatrica:{
            ask1:{ label:'¿Esta usted satisfecho con su vida?', answer: null },
            ask2:{ label:'¿Ha dejado muchas de sus actividades e intereses?', answer: null },
            ask3:{ label:'¿Siente que su vida ha sido vacía?', answer: null },
            ask4:{ label:'¿Se siete aburrido a menudo?', answer: null },
            ask5:{ label:'¿Se mantiene en un buen estado de ánimo la mayor parte del tiempo?', answer: null },
            ask6:{ label:'¿Tiene temor que le pueda ocurrir algo malo?', answer: null },
            ask7:{ label:'¿Se siente feliz la mayor parte del tiempo?', answer: null },
            ask8:{ label:'¿Se siente a menudo impotente?', answer: null },
            ask9:{ label:'¿Prefiere quedarse en casa en vez de salir a conocer cosas nuevas?', answer: null },
            ask10:{ label:'¿Considera que tiene mas problemas con la memoria que el resto de las personas?', answer: null },
            ask11:{ label:'¿Considera que es maravilloso estar vivo ahora?', answer: null },
            ask12:{ label:'¿Se siente infravalorado por la forma en la que ahora se encuentra?', answer: null },
            ask13:{ label:'¿Se siente lleno de energía?', answer: null },
            ask14:{ label:'¿Se siente sin esperanza en su situación actual?', answer: null },
            ask15:{ label:'¿Creen que la mayor parte de las personas está mejor que usted?', answer: null }
        },

        neuro_examen_fisico:{
            frecuencia_c:{
                label:'Frecuencia cardiaca (FC)',
                value: ''
            },
            presion_a:{
                label:'Presión arteríal (PA)',
                value: ''
            },
            nivel_conciencia:{
                label:'Nivel de conciencia',
                options: [
                    {option: 'Colaboración', value: false},
                    {option: 'Indiferencia', value: false},
                    {option: 'Agresividad', value: false},
                    {option: 'Depresión', value: false},
                    {option: 'Negativismo', value: false},
                    {option: 'Liberación Emocional', value: false},
                    {option: 'Euforia', value: false},
                    {option: 'Inestabilidad', value: false},
                ]
            }

        },

        inspeccion:{
            edema_tedijo_blando:{
                label:'Edema en tejidos blandos (Zonas)',
                value:''
            },
            estado_piel:{
                label:'Estado de piel',
                value:''
            },
            estado_unia:{
                label:'Estado de las Uñas',
                value:''
            }
        },

        sensibilidad_superficial:{
            tactil:{
                label:'Sensibilidad tactil',
                normoestesia: '',
                hiperestesia: '',
                hipoetesia: '',
                disestesia: '',
            },
            d_super:{
                label:'Dolor Superficial',
                normoestesia: '',
                hiperestesia: '',
                hipoetesia: '',
                disestesia: '',
            },
            temperatura:{
                label:'Temperatura',
                normoestesia: '',
                hiperestesia: '',
                hipoetesia: '',
                disestesia: '',
            },
        },

        sensibilidad_profunda:{
            batiestesia:{
                label:'Batiestesia',
                normoestesia: '',
                hiperestesia: '',
                hipoetesia: '',
                disestesia: '',
            },
            vibracion:{
                label:'Vibración',
                normoestesia: '',
                hiperestesia: '',
                hipoetesia: '',
                disestesia: '',
            },
            dolor_profundo:{
                label:'Dolor Profundo',
                normoestesia: '',
                hiperestesia: '',
                hipoetesia: '',
                disestesia: '',
            },
        },

        sensibilidad_cortical:{
            somatognopsia:{
                label:'Somatognopsia',
                value: ''
            },
            esterognosia:{
                label:'Esterognosia',
                value: ''
            },
            discriminacion_puntos:{
                label:'Discriminación de dos puntos',
                value: ''
            },
            grafestesia:{
                label:'Grafestesia',
                value: ''
            },
            barognosia:{
                label:'Barognosia',
                value: ''
            }
        },

        tono_muscular:{
            hipertonia:{
                label:'Hipertonía',
                value: ''
            },
            hipotonia:{
                label:'Hipotonía',
                value: ''
            },
            patron:{
                label:'Patrón Flexor o Extensor (Si lo tiene)',
                value: ''
            },
            comentarios:{
                label:'Comentarios del examinador',
                value: ''
            }
        },

        reflejos:[
            {
                nombre: 'Bicipital',
                segmento: 'C5',
                lado: 'Izquierdo',
                respuesta: '',
                observaciones: ''
            },
            {
                nombre: 'Tricipital',
                segmento: 'C6–C7',
                lado: 'Izquierdo',
                respuesta: '',
                observaciones: ''
            },
            {
                nombre: 'Rotuliano',
                segmento: 'L2–L4',
                lado: 'Izquierdo',
                respuesta: '',
                observaciones: ''
            },
            {
                nombre: 'Aquiliano',
                segmento: 'S1',
                lado: 'Izquierdo',
                respuesta: '',
                observaciones: ''
            }
        ],

        rangos_articulares: [], // Array to hold ROM data
        articulaciones_options: [ // Options for Articulación dropdown
            'Hombro', 'Codo', 'Muñeca', 'Dedos Mano', 'Cadera', 'Rodilla', 'Tobillo', 'Pie', 'Columna Cervical', 'Columna Dorsolumbar'
        ],
        movimientos_options: { // Options for Movimiento dropdown, grouped by articulation
            'Hombro': ['Flexión', 'Extensión', 'Abducción', 'Aducción', 'Rotación Interna', 'Rotación Externa'],
            'Codo': ['Flexión', 'Extensión', 'Pronación', 'Supinación'],
            'Muñeca': ['Flexión', 'Extensión', 'Desviación Radial', 'Desviación Cubital'],
            'Dedos Mano': ['Flexión MCF', 'Extensión MCF', 'Flexión IFP', 'Extensión IFP', 'Flexión IFD', 'Extensión IFD', 'Abducción', 'Aducción'],
            'Cadera': ['Flexión', 'Extensión', 'Abducción', 'Aducción', 'Rotación Interna', 'Rotación Externa'],
            'Rodilla': ['Flexión', 'Extensión'],
            'Tobillo': ['Dorsiflexión', 'Plantarflexión', 'Inversión', 'Eversión'],
            'Pie': ['Flexión Dedos', 'Extensión Dedos'],
            'Columna Cervical': ['Flexión', 'Extensión', 'Inclinación Lateral Izq', 'Inclinación Lateral Der', 'Rotación Izq', 'Rotación Der'],
            'Columna Dorsolumbar': ['Flexión', 'Extensión', 'Inclinación Lateral Izq', 'Inclinación Lateral Der', 'Rotación Izq', 'Rotación Der']
        },
        lado_options: ['Izquierdo', 'Derecho'], // Options for Lado dropdown
        rom_normals: { // Standard ROM values (example, needs completion)
            'Hombro-Flexión': '0-180°', 'Hombro-Extensión': '0-60°', 'Hombro-Abducción': '0-180°', 'Hombro-Aducción': '0-45°', 'Hombro-Rotación Interna': '0-70°', 'Hombro-Rotación Externa': '0-90°',
            'Codo-Flexión': '0-150°', 'Codo-Extensión': '0°', 'Codo-Pronación': '0-80°', 'Codo-Supinación': '0-80°',
            'Muñeca-Flexión': '0-80°', 'Muñeca-Extensión': '0-70°', 'Muñeca-Desviación Radial': '0-20°', 'Muñeca-Desviación Cubital': '0-30°',
            'Cadera-Flexión': '0-120°', 'Cadera-Extensión': '0-30°', 'Cadera-Abducción': '0-45°', 'Cadera-Aducción': '0-30°', 'Cadera-Rotación Interna': '0-45°', 'Cadera-Rotación Externa': '0-45°',
            'Rodilla-Flexión': '0-135°', 'Rodilla-Extensión': '0-15°',
            'Tobillo-Dorsiflexión': '0-20°', 'Tobillo-Plantarflexión': '0-50°', 'Tobillo-Inversión': '0-35°', 'Tobillo-Eversión': '0-15°',
            'Columna Cervical-Flexión': '0-45°', 'Columna Cervical-Extensión': '0-45°', 'Columna Cervical-Inclinación Lateral Izq': '0-45°', 'Columna Cervical-Inclinación Lateral Der': '0-45°', 'Columna Cervical-Rotación Izq': '0-60°', 'Columna Cervical-Rotación Der': '0-60°',
            // ... Add more standard values as needed
        },

        sensacion_final:{
        },

        fuerza_muscular:{
        },

        pruebas_especiales:{
        },

        concluciones_g:{
            ac_fisioterapeutico:'',
            conclucion_tratamiento:''
        },

        patron_capsular:{
                label: 'Patrón Capsular (Si lo presenta), Segmento(s)',
                value: '',
        },

        patrones_capsulares: [
            {
                articulacion: "Hombro",
                patron: ""
            },
            {
                articulacion: "Codo",
                patron: ""
            },
            {
                articulacion: "Muñeca",
                patron: ""
            },
            {
                articulacion: "Cadera",
                patron: ""
            },
            {
                articulacion: "Rodilla",
                patron: ""
            },
            {
                articulacion: "Tobillo",
                patron: ""
            }
        ],

 }},
 computed: {
        ...mapGetters({
            GetMedicoFichaActive: 'GetMedicoFichaActive',
            GetReloadFicha: 'GetReloadFicha',
        })
    },
    watch: {
        GetReloadFicha(newValue, oldValue) {
            if (newValue === false && oldValue === true) {
                // Data loading is handled by GetMedicoFichaActive watcher
            }
        },
        GetMedicoFichaActive: {
            handler(newVal) {
                if (newVal && newVal.metadata) {
                    this.loadHistorialGeriatrico(newVal.metadata.historial_geriatrico);
                    this.loadFormularioMental(newVal.metadata.formulario_mental);
                    this.loadIndiceBarthel(newVal.metadata.indice_barthel);
                    this.loadLawtonBrody(newVal.metadata.lawton_brody);
                    this.loadEvaluacionDolor(newVal.metadata.evaluacion_dolor);
                    this.loadEvaluacionPostural(newVal.metadata.evaluacion_postural);
                    this.loadDepreGeriatrica(newVal.metadata.depre_geriatrica);
                    this.loadNeuroExamenFisico(newVal.metadata.neuro_examen_fisico);
                    this.loadInspeccion(newVal.metadata.inspeccion);
                    this.loadSensibilidad('sensibilidad_superficial', newVal.metadata.sensibilidad_superficial);
                    this.loadSensibilidad('sensibilidad_profunda', newVal.metadata.sensibilidad_profunda);
                    this.loadSensibilidad('sensibilidad_cortical', newVal.metadata.sensibilidad_cortical);
                    this.loadTonoMuscular(newVal.metadata.tono_muscular);
                    this.loadReflejos(newVal.metadata.reflejos);
                    this.loadPatronesCapsulares(); // Already implemented
                    this.loadConclusiones(newVal.metadata.concluciones_g);
                    // Note: Rangos articulares, sensacion_final, fuerza_muscular, pruebas_especiales are loaded via GetMedicoFichaActive.metadata directly in the template v-for
                }
            },
            deep: true,
            immediate: true
        }
    },
    components: {
        Box
    },
    mounted() {
        // Se refresca la ficha y se mandan los slugs que usa el tab de la consulta
        this.emitter.emit("medico-ficha-load",['historial_geriatrico','formulario_mental','indice_barthel','lawton_brody', 'evaluacion_dolor', 'evaluacion_postural', 'depre_geriatrica', 'neuro_examen_fisico', 'inspeccion', 'sensibilidad_superficial', 'sensibilidad_profunda', 'sensibilidad_cortical', 'reflejos', 'tono_muscular', 'patron_capsular', 'pruebas_especiales', 'fuerza_muscular', 'sensacion_final', 'rangos_articulares', 'patron_capsular', 'concluciones_g']);
    },
    methods:{
    dayjs,
    Numbro,
    handleCheckStyle(item){
       if (item.check) {
            return "check-style";
        }
        // Return empty string or a default class if not checked
        return "";
    },
    // --- Data Loading Methods ---
    loadHistorialGeriatrico(data) {
        if (data) {
            this.historial_geriatrico.nutricional = data.nutricional || '';
            this.historial_geriatrico.psiquiatrica = data.psiquiatrica || '';
            this.historial_geriatrico.anamnesis = data.anamnesis || '';
        } else {
            this.historial_geriatrico = { nutricional: '', psiquiatrica: '', anamnesis: '' };
        }
    },
    loadFormularioMental(data) {
        if (data) {
            let totalScore = 0;
            for (const sectionKey in this.formulario_mental) {
                const section = this.formulario_mental[sectionKey];
                for (const itemKey in section) {
                    const checkKey = `${sectionKey}_${itemKey}_check`;
                    const detailKey = `${sectionKey}_${itemKey}_detailValue`;
                    if (data.hasOwnProperty(checkKey)) {
                        section[itemKey].check = data[checkKey];
                        if (section[itemKey].check) {
                            totalScore += section[itemKey].score;
                        }
                    } else {
                         section[itemKey].check = false; // Default if not present
                    }
                    if (data.hasOwnProperty(detailKey)) {
                        section[itemKey].detailValue = data[detailKey];
                    } else {
                        section[itemKey].detailValue = ''; // Default if not present
                    }
                }
            }
            this.fm_TotalScore = totalScore;
        } else {
             // Reset if no data
             for (const sectionKey in this.formulario_mental) {
                const section = this.formulario_mental[sectionKey];
                for (const itemKey in section) {
                    section[itemKey].check = false;
                    section[itemKey].detailValue = '';
                }
            }
            this.fm_TotalScore = 0;
        }
    },
    loadIndiceBarthel(data) {
        if (data) {
            let totalScore = 0;
            for (const key in this.indice_barthel) {
                const scoreKey = `${key}_score`;
                if (data.hasOwnProperty(scoreKey)) {
                    const score = parseInt(data[scoreKey]) || 0;
                    this.indice_barthel[key].score = score;
                    totalScore += score;
                } else {
                    this.indice_barthel[key].score = 0; // Default
                }
            }
            this.ib_TotalScore = totalScore;
        } else {
            for (const key in this.indice_barthel) {
                this.indice_barthel[key].score = 0;
            }
            this.ib_TotalScore = 0;
        }
    },
    loadLawtonBrody(data) {
        if (data) {
            let totalScore = 0;
            for (const key in this.lawton_brody) {
                if (key === 'comentarios') {
                    const contentKey = `${key}_content`;
                    this.lawton_brody[key].content = data.hasOwnProperty(contentKey) ? data[contentKey] : '';
                } else {
                    const scoreKey = `${key}_score`;
                    if (data.hasOwnProperty(scoreKey)) {
                        const score = parseInt(data[scoreKey]) || 0;
                        this.lawton_brody[key].score = score;
                        totalScore += score;
                    } else {
                         this.lawton_brody[key].score = 0; // Default
                    }
                }
            }
            this.lb_TotalScore = totalScore;
        } else {
             for (const key in this.lawton_brody) {
                 if (key === 'comentarios') {
                     this.lawton_brody[key].content = '';
                 } else {
                    this.lawton_brody[key].score = 0;
                 }
            }
            this.lb_TotalScore = 0;
        }
    },
    loadEvaluacionDolor(data) {
        if (data) {
            for (const sectionKey in this.evaluacion_dolor) {
                if (sectionKey === 'primary_question') {
                    for (const itemKey in this.evaluacion_dolor[sectionKey]) {
                        const valueKey = `${sectionKey}_${itemKey}_value`;
                        const defaultValue = (this.evaluacion_dolor[sectionKey][itemKey].type === 'select' ? (this.evaluacion_dolor[sectionKey][itemKey].options[0] && this.evaluacion_dolor[sectionKey][itemKey].options[0].value || '') : '');
                        this.evaluacion_dolor[sectionKey][itemKey].value = data.hasOwnProperty(valueKey) ? data[valueKey] : defaultValue;
                    }
                } else {
                    const valueKey = `${sectionKey}_value`;
                    this.evaluacion_dolor[sectionKey].value = data.hasOwnProperty(valueKey) ? data[valueKey] : '';
                }
            }
        } else {
            // Reset if no data
            for (const sectionKey in this.evaluacion_dolor) {
                 if (sectionKey === 'primary_question') {
                     for (const itemKey in this.evaluacion_dolor[sectionKey]) {
                         this.evaluacion_dolor[sectionKey][itemKey].value = (this.evaluacion_dolor[sectionKey][itemKey].type === 'select' ? (this.evaluacion_dolor[sectionKey][itemKey].options[0] && this.evaluacion_dolor[sectionKey][itemKey].options[0].value || '') : '');
                     }
                 } else {
                    this.evaluacion_dolor[sectionKey].value = '';
                 }
            }
        }
    },
    loadEvaluacionPostural(data) {
        if (data) {
            for (const key in this.evaluacion_postural) {
                const valueKey = `${key}_value`;
                this.evaluacion_postural[key].value = data.hasOwnProperty(valueKey) ? data[valueKey] : '';
            }
        } else {
            for (const key in this.evaluacion_postural) {
                this.evaluacion_postural[key].value = '';
            }
        }
    },
    loadDepreGeriatrica(data) {
        if (data) {
            for (const key in this.depre_geriatrica) {
                const answerKey = `${key}_answer`;
                this.depre_geriatrica[key].answer = data.hasOwnProperty(answerKey) ? data[answerKey] : null;
            }
            this.calculateGdsScore(); // Recalculate score after loading
        } else {
             for (const key in this.depre_geriatrica) {
                this.depre_geriatrica[key].answer = null;
            }
            this.dp_TotalScore = 0;
        }
    },
    loadNeuroExamenFisico(data) {
        if (data) {
            this.neuro_examen_fisico.frecuencia_c.value = data.frecuencia_c_value || '';
            this.neuro_examen_fisico.presion_a.value = data.presion_a_value || '';
            this.neuro_examen_fisico.nivel_conciencia.options.forEach((option, index) => {
                const key = `nivel_conciencia_option_${index}`;
                option.value = data.hasOwnProperty(key) ? data[key] : false;
            });
        }
    },
    loadInspeccion(data) {
        if (data) {
            this.inspeccion.edema_tedijo_blando.value = data.edema_tedijo_blando || '';
            this.inspeccion.estado_piel.value = data.estado_piel || '';
            this.inspeccion.estado_unia.value = data.estado_unia || '';
        } else {
            this.inspeccion.edema_tedijo_blando.value = '';
            this.inspeccion.estado_piel.value = '';
            this.inspeccion.estado_unia.value = '';
        }
    },
    loadSensibilidad(slug, data) {
        const targetObject = this[slug];
        if (data && targetObject) {
            for (const typeKey in targetObject) { // e.g., tactil, d_super
                const typeObject = targetObject[typeKey];
                for (const responseKey in typeObject) { // e.g., normoestesia, hiperestesia, value
                    if (responseKey !== 'label') {
                        const dataKey = `${typeKey}_${responseKey}`;
                        typeObject[responseKey] = data.hasOwnProperty(dataKey) ? data[dataKey] : '';
                    }
                }
            }
        } else if (targetObject) {
            // Reset if no data
            for (const typeKey in targetObject) {
                const typeObject = targetObject[typeKey];
                for (const responseKey in typeObject) {
                     if (responseKey !== 'label') {
                         typeObject[responseKey] = '';
                     }
                }
            }
        }
    },
    loadTonoMuscular(data) {
        if (data) {
            this.tono_muscular.hipertonia.value = data.hipertonia_value || '';
            this.tono_muscular.hipotonia.value = data.hipotonia_value || '';
            this.tono_muscular.patron.value = data.patron_value || '';
            this.tono_muscular.comentarios.value = data.comentarios_value || '';
        } else {
            this.tono_muscular.hipertonia.value = '';
            this.tono_muscular.hipotonia.value = '';
            this.tono_muscular.patron.value = '';
            this.tono_muscular.comentarios.value = '';
        }
    },
    loadReflejos(data) {
        if (data) {
            const loadedReflejos = [];
            let index = 0;
            while (data.hasOwnProperty(`${index}_nombre`)) {
                loadedReflejos.push({
                    nombre: data[`${index}_nombre`] || '',
                    segmento: data[`${index}_segmento`] || '',
                    lado: data[`${index}_lado`] || 'Izquierdo',
                    respuesta: data[`${index}_respuesta`] || '0',
                    observaciones: data[`${index}_observaciones`] || ''
                });
                index++;
            }
            // Only update if loaded data is not empty, otherwise keep default
            if(loadedReflejos.length > 0) this.reflejos = loadedReflejos;
        }
        // Keep default reflejos if no data is loaded
    },
    loadConclusiones(data) {
        if (data) {
            this.concluciones_g.ac_fisioterapeutico = data.ac_fisioterapeutico || '';
            this.concluciones_g.conclucion_tratamiento = data.conclucion_tratamiento || '';
        } else {
            this.concluciones_g.ac_fisioterapeutico = '';
            this.concluciones_g.conclucion_tratamiento = '';
        }
    },
    // --- End Data Loading Methods ---
    saveConcluciones(){
        const self = this;

        // transformo los keys a un array normal
        const arrToSave = {};
        Object.keys(self.concluciones_g).map(function (value) {
            if (self.concluciones_g[value] !== '') arrToSave[value] = self.concluciones_g[value];
        });

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'concluciones_g',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['concluciones_g']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    savePruebaEspecial(){
        const self = this;

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                metadataId: self.pruebas_especiales.id,
                slug: 'pruebas_especiales',
                detail: self.pruebas_especiales.detail,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-refresh",['pruebas_especiales']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });

        this.cancelAddOrEditPruebaEspecial();
    },
    cancelAddOrEditPruebaEspecial(){
        this.showAddPruebaEspecial = false;
        this.showEditionPruebaEspecial = false;
        this.pruebas_especiales={};
    },
    newPruebaEspecial(){
        this.pruebas_especiales={
            id:0,
            detail:{
                miembro_segmento:'',
                prueba:'',
                hallazgo:''
            }
        }
        this.showAddPruebaEspecial = true;
    },
    saveFuerzaM(){
        const self = this;

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                metadataId: self.fuerza_muscular.id,
                slug: 'fuerza_muscular',
                detail: self.fuerza_muscular.detail,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-refresh",['fuerza_muscular']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });

        this.cancelAddOrEditFuerzaM();
    },
    cancelAddOrEditFuerzaM(){
        this.showAddFuerzaM = false;
        this.showEditionFuerzaM = false;
        this.fuerza_muscular={};
    },
    newFuerzaM(){
        this.fuerza_muscular={
            id:0,
            detail:{
                miembro_segmento:'',
                musculo:'',
                fuerza:''
            }
        }
        this.showAddFuerzaM = true;
    },
    saveSensacionFinal(){
        const self = this;

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                metadataId: self.sensacion_final.id,
                slug: 'sensacion_final',
                detail: self.sensacion_final.detail,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-refresh",['sensacion_final']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });

        this.cancelAddOrEditSensaFinal();
    },
    cancelAddOrEditSensaFinal(){
        this.showAddSensacion = false;
        this.showEditionSensacion = false;
        this.sensacion_final={};
    },
    newSensacionFinal(){
        this.sensacion_final = {
            id:0,
            detail:{
                miembro_segmento:'',
                tipo_sensacion:'',
                dolor:''
            }
        }
        this.showAddSensacion = true;
    },
    resetRango() {
        this.editingRango = {
            id: 0,
            detail: {
                articulacion: '',
                movimiento: '',
                lado: 'Izquierdo',
                rango_activo: null,
                rango_pasivo: null,
                hallazgos: ''
            }
        };
    },
    addRango() {
        this.resetRango();
        this.showAddRango = true;
        this.showEditionRango = false; // Ensure only one state is active
    },
    editRango(item) {
        // Create a deep copy to avoid modifying the original item directly
        this.editingRango = JSON.parse(JSON.stringify(item));
        // Ensure detail exists if the structure is different
        if (!this.editingRango.detail) {
            this.editingRango.detail = {}; // Or handle appropriately
        }
        this.showEditionRango = true;
        this.showAddRango = false; // Ensure only one state is active
    },
    cancelEditRango() {
        this.resetRango();
        this.showAddRango = false;
        this.showEditionRango = false;
    },
    saveRango() {
        const self = this;
        // Basic validation
        if (!self.editingRango.detail.articulacion || !self.editingRango.detail.movimiento) {
            API.showErrorAlert('Debe seleccionar Articulación y Movimiento.');
            return;
        }

        const dataToSend = {
            orderId: self.GetMedicoFichaActive.orden.id,
            slug: 'rangos_articulares',
            detail: self.editingRango.detail,
        };
        if (self.editingRango.id && self.editingRango.id !== 0) {
            dataToSend.metadataId = self.editingRango.id;
        }

        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                metadataId: self.editingRango.id, // Use editingRango.id
                slug: 'rangos_articulares',
                detail: self.editingRango.detail, // Use editingRango.detail
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-refresh",['rangos_articulares']);
                self.cancelEditRango(); // Close form on success
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    deleteRango(item) {
        const self = this;
        API.showConfirm('¿Está seguro de eliminar este rango articular?', '', function () {
            API.send('POST', 'orders/metadata/delete', {
                metadataId: item.id, // Use the id from the item passed
            }, function (response) {
                API.showSuccessAlert(response.msg);
                // Emit refresh event to reload data from the server
                self.emitter.emit("medico-ficha-refresh", ['rangos_articulares']);
            }, function (response) {
                API.showErrorAlert(response.msg);
            });
        });
    },
    savePatronCapsular(){
        const self = this;

        // transformo los keys a un array normal
        const arrToSave = {};
       
            if (self.patron_capsular.value !== '') arrToSave['value'] = self.patron_capsular.value;
     

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'patron_capsular',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['patron_capsular']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveTonoMuscular(){
        const self = this;

        const arrToSave = {};
       
            Object.keys(self.tono_muscular).map(function (value) {
            Object.keys(self.tono_muscular[value]).map(function (value2) {
            if(value2 != 'label')
            arrToSave[value+'_'+value2] = self.tono_muscular[value][value2];
            });
            });
        

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'tono_muscular',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['tono_muscular']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveReflejo(){
        const self = this;
        const arrToSave = {};

        // Flatten the array structure for the API
        self.reflejos.forEach((item, index) => {
            arrToSave[`${index}_nombre`] = item.nombre;
            arrToSave[`${index}_segmento`] = item.segmento;
            arrToSave[`${index}_lado`] = item.lado;
            arrToSave[`${index}_respuesta`] = item.respuesta;
            arrToSave[`${index}_observaciones`] = item.observaciones;
        });
   
        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'reflejos',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['reflejos']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveSensibilidad(slug){
        const self = this;

        const arrToSave = {};
        if (slug=== 'sensibilidad_superficial') {
            Object.keys(self.sensibilidad_superficial).map(function (value) {
            Object.keys(self.sensibilidad_superficial[value]).map(function (value2) {
            if(value2 != 'label')
            arrToSave[value+'_'+value2] = self.sensibilidad_superficial[value][value2];
            });
            });
        }
        else if (slug=== 'sensibilidad_profunda') {
                     Object.keys(self.sensibilidad_profunda).map(function (value) {
                        Object.keys(self.sensibilidad_profunda[value]).map(function (value2) {
            if(value2 != 'label')
            arrToSave[value+'_'+value2] = self.sensibilidad_profunda[value][value2];
            });
            });
        }
        else if (slug=== 'sensibilidad_cortical') {
            Object.keys(self.sensibilidad_cortical).map(function (value) {
            Object.keys(self.sensibilidad_cortical[value]).map(function (value2) {
            if(value2 != 'label')
            arrToSave[value+'_'+value2] = self.sensibilidad_cortical[value][value2];
            });
            });
        }
       
        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: slug,
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",[slug]);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveInspeccion(){
        const self = this;

        const arrToSave = {};
        Object.keys(self.inspeccion).map(function (value) {
           arrToSave[value] = self.inspeccion[value].value;
        });
        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'inspeccion',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['inspeccion']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveNeuroExamenFisico(){
        const self = this;

        const arrToSave = {};
        Object.keys(self.neuro_examen_fisico).map(function (value) {

            if (value != 'nivel_conciencia'){
            arrToSave[value+'_value'] = self.neuro_examen_fisico[value].value;
            }else{
                self.neuro_examen_fisico[value].options.map(function (item,index) {
                    arrToSave[value+'_option_'+index] = item.value;
                })
            }

        });

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'neuro_examen_fisico',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['neuro_examen_fisico']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    onChangeDetail(item){
            item.detail=!item.detail;
    },
    saveHistorialGeriatric(){
      const self = this;

      // transformo los keys a un array normal
      const arrToSave = {};
      Object.keys(self.historial_geriatrico).map(function (value) {
          if (self.historial_geriatrico[value] !== '') arrToSave[value] = self.historial_geriatrico[value];
      });

      // Guardo y luego emito el evento
      API.send('POST', 'orders/metadata/save/', {
              orderId: self.GetMedicoFichaActive.orden.id,
              slug: 'historial_geriatrico',
              detail: arrToSave,
              uniqueMeta: 1,
          }, function (response) {
              API.showSuccessAlert(response.msg);
              self.emitter.emit("medico-ficha-notify",['historial_geriatrico']);
          },
          function (response) {
              API.showErrorAlert(response.msg);
          });
    },
    saveFormularioMental(){
        const self = this;
        self.fm_TotalScore= 0;
        // transformo los keys a un array normal
        const arrToSave = {};
        Object.keys(self.formulario_mental).map(function (value) {
            let groptest = self.formulario_mental[value]; 
            Object.keys(groptest).map(function (value2) {
                let itemtest = groptest[value2];
                arrToSave[value+'_'+value2+'_check'] = itemtest.check;
                arrToSave[value+'_'+value2+'_detailValue'] = itemtest.detailValue;
                self.formulario_mental[value][value2].check ? (self.fm_TotalScore =  self.fm_TotalScore+self.formulario_mental[value][value2].score) : ''
            });
        });

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'formulario_mental',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['formulario_mental']);

            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveBarthel(){
        const self = this;
        self.ib_TotalScore = 0;
        // transformo los keys a un array normal
        const arrToSave = {};
        Object.keys(self.indice_barthel).map(function (value) {
            const item = self.indice_barthel[value];
            arrToSave[value+'_score'] = item.score ? parseInt(item.score) : 0;
            self.ib_TotalScore += item.score ? parseInt(item.score) : 0;
        });

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'indice_barthel',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['indice_barthel']);
            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveLawtonbrody(){
        const self = this;
        self.lb_TotalScore= 0;
        // transformo los keys a un array normal
        const arrToSave = {};
        Object.keys(self.lawton_brody).map(function (value) {
            if(value!=='comentarios'){
                arrToSave[value+'_score'] = self.lawton_brody[value].score ? parseInt(self.lawton_brody[value].score) : 0;
                self.lb_TotalScore +=  self.lawton_brody[value].score ? parseInt(self.lawton_brody[value].score) : 0;
            }else{
                arrToSave[value+'_content'] = self.lawton_brody[value].content ?  self.lawton_brody[value].content : ''
            }
        });
        
        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'lawton_brody',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['lawton_brody']);

            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
  
    },
    saveEvaluacionDolor(){
        const self = this;

        const arrToSave = {};
        Object.keys(self.evaluacion_dolor).map(function (value) {
            if(value === 'primary_question'){
                Object.keys(self.evaluacion_dolor[value]).map(function (value2) {
                arrToSave[value+'_'+value2+'_value'] = self.evaluacion_dolor[value][value2].value ?  self.evaluacion_dolor[value][value2].value : ''
            });
            }else{
                arrToSave[value+'_value'] = self.evaluacion_dolor[value].value;
            }  
        });
        
        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'evaluacion_dolor',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['evaluacion_dolor']);

            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveEvaluacionPostural(){
        const self = this;

        const arrToSave = {};
        Object.keys(self.evaluacion_postural).map(function (value) {
                arrToSave[value+'_value'] = self.evaluacion_postural[value].value;
        });

        // Guardo y luego emito el evento
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'evaluacion_postural',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                API.showSuccessAlert(response.msg);
                self.emitter.emit("medico-ficha-notify",['evaluacion_postural']);

            },
            function (response) {
                API.showErrorAlert(response.msg);
            });
    },
    saveDepreGeriatrica(){
        const self = this;
        const arrToSave = {};
        // Flatten the data structure for the API
        Object.keys(self.depre_geriatrica).map(function (key) {
                // Only save if an answer is selected
                if (self.depre_geriatrica[key].answer !== null) {
                    arrToSave[key+'_answer'] = self.depre_geriatrica[key].answer;
                }
        });

        // Calculate score locally immediately after change
        self.calculateGdsScore();

        // Send flattened data to API
        API.send('POST', 'orders/metadata/save/', {
                orderId: self.GetMedicoFichaActive.orden.id,
                slug: 'depre_geriatrica',
                detail: arrToSave,
                uniqueMeta: 1,
            }, function (response) {
                // Notify other components if needed
                self.emitter.emit("medico-ficha-notify",['depre_geriatrica']);
                // Score is already updated locally
            },
            function (response) {
                API.showErrorAlert(response.msg);
                // Optionally revert local changes or re-fetch data on error
            });
    },
    calculateGdsScore() {
      let score = 0;
      for (const key in this.depre_geriatrica) {
        // Check if the answer exists and matches the scoring key
        if (this.depre_geriatrica[key].answer && this.depre_geriatrica[key].answer === gdsScoringKey[key]) {
          score++;
        }
      }
      this.dp_TotalScore = score;
    },
    handleCheckStyle2(item){
            if(item.answer === 'No'){
                return "cancel-style";
            }else if (item.answer === 'Sí') {
                return "check-style";
            }
        },
    getNormalRom(articulacion, movimiento) {
        if (!articulacion || !movimiento) return 'N/A';
        const key = `${articulacion}-${movimiento}`;
        return this.rom_normals[key] || 'N/A';
    },
    getMovimientoOptions(articulacion) {
        return this.movimientos_options[articulacion] || [];
    },
    loadPatronesCapsulares() {
        const self = this;
        if (self.GetMedicoFichaActive.metadata && self.GetMedicoFichaActive.metadata.patron_capsular) {
            const patronesData = self.GetMedicoFichaActive.metadata.patron_capsular;
            // Cargar los datos manteniendo la estructura original
            self.patrones_capsulares = self.patrones_capsulares.map((patron, index) => ({
                articulacion: patron.articulacion,
                patron: patronesData[`patron_${index}_patron`] || ""
            }));
        }
    },
    savePatronesCapsulares() {
        const self = this;
        const arrToSave = {};
        
        // Convertir a formato plano
        self.patrones_capsulares.forEach((item, index) => {
            arrToSave[`patron_${index}_articulacion`] = item.articulacion;
            arrToSave[`patron_${index}_patron`] = item.patron;
        });

        // Guardar en metadata
        API.send('POST', 'orders/metadata/save/', {
            orderId: self.GetMedicoFichaActive.orden.id,
            slug: 'patron_capsular',
            detail: arrToSave,
            uniqueMeta: 1,
        }, function (response) {
            API.showSuccessAlert(response.msg);
            self.emitter.emit("medico-ficha-notify",['patron_capsular']);
        },
        function (response) {
            API.showErrorAlert(response.msg);
        });
    },
  }
 }
</script>
 
 
<template>
  <box  title="Análisis primario" icon="fa-solid fa-clipboard-user" :contraction='true'>
      <div class="row mx-2">
        <div class="col-12">
            <div class="form-group mb-2">
                <label>Historia nutricional</label>
                <textarea v-model="historial_geriatrico.nutricional" class="form-control" placeholder="Escribe aquí" @change="saveHistorialGeriatric"></textarea>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group mb-2">
                <label>Historia psiquiatrica</label>
                <textarea v-model="historial_geriatrico.psiquiatrica" class="form-control" placeholder="Escribe aquí" @change="saveHistorialGeriatric"></textarea>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group mb-2">
                <label>Anamnesis medica</label>
                <textarea v-model="historial_geriatrico.anamnesis" class="form-control" placeholder="Escribe aquí" @change="saveHistorialGeriatric"></textarea>
            </div>
        </div>
      </div>
  </box>
  <box  title="Formulario mental" icon="fa-solid fa-brain" :contraction='true'> 
      <div class="d-flex flex-column justify-content-center w-100">
        <div class="form-group w-100">
                <label class=" d-flex flex-column " ><small :class="fm_TotalScore < 26 ? 'text-danger' : 'text-muted'">*La puntuación inferior a 26 puntos puede indicar la necesidad de otras pruebas de evaluación. El diagnostico cognoscitivo determinado mediante esta prueba varía según el nivel educativo del paciente.</small></label>
                        <table class="table">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col" class="font-weight-bold">
                                Actividad
                                </th>
                              
                                <th scope="col" class="font-weight-bold">
                                  <div class="d-flex justify-content-center">
                                    Listo
                                  </div>
                                </th>
                            </tr>
                            </thead>
                            <tbody class="table-hover">
                            <tr>
                              <td colspan="2"><span class="text-primary">*Preguntas de orientacion</span></td>
                            </tr>
                            <tr v-for="(item,key) in formulario_mental.orientacion" class="inputGroup bgtr" :class="handleCheckStyle(item)" :key="key">
                                <td>
                                  <div class="mb-2">
                                    {{ item.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="item.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option">
                                        <label :for="`check${item.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${item.ask}`" class="check" name="check" type="checkbox" v-model="item.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="item.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622  l140.894-140.898l31.309,31.309L174.199,322.918z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*¿Donde estamos?</span></td>
                            </tr>
                            <tr v-for="(item,key) in formulario_mental.ubicacion" class="inputGroup bgtr" :class="handleCheckStyle(item)" :key="key">
                                <td>
                                  <div class="mb-2">
                                    {{ item.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="item.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option cursor-pointer">
                                        <label :for="`check${item.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${item.ask}`" class="check" name="check" type="checkbox" v-model="item.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="item.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.153,0,213.333,0z M330.995,276.689l-54.302,54.306l-63.36-63.356l-63.36,63.36l-54.302-54.31  l63.356-63.356l-63.356-63.36l54.302-54.302l63.36,63.356l63.36-63.356l54.302,54.302l-63.356,63.36L330.995,276.689z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Registro</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.registro.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.registro.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.registro.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option cursor-pointer">
                                        <label :for="`check${formulario_mental.registro.test.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${formulario_mental.registro.test.ask}`" class="check cursor-pointer" name="check" type="checkbox" v-model="formulario_mental.registro.test.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="formulario_mental.registro.test.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.153,0,213.333,0z M330.995,276.689l-54.302,54.306l-63.36-63.356l-63.36,63.36l-54.302-54.31  l63.356-63.356l-63.356-63.36l54.302-54.302l63.36,63.356l63.36-63.356l54.302,54.302l-63.356,63.36L330.995,276.689z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Atención y Calculo</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.calculo.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.calculo.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.calculo.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option cursor-pointer">
                                        <label :for="`check${formulario_mental.calculo.test.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${formulario_mental.calculo.test.ask}`" class="check cursor-pointer" name="check" type="checkbox" v-model="formulario_mental.calculo.test.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="formulario_mental.calculo.test.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.153,0,213.333,0z M330.995,276.689l-54.302,54.306l-63.36-63.356l-63.36,63.36l-54.302-54.31  l63.356-63.356l-63.356-63.36l54.302-54.302l63.36,63.356l63.36-63.356l54.302,54.302l-63.356,63.36L330.995,276.689z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Memoria</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.memoria.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.memoria.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.memoria.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option cursor-pointer">
                                        <label :for="`check${formulario_mental.memoria.test.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${formulario_mental.memoria.test.ask}`" class="check" name="check" type="checkbox" v-model="formulario_mental.memoria.test.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="formulario_mental.memoria.test.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622  l140.894-140.898l31.309,31.309L174.199,322.918z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Nombrar</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.nombrar.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.nombrar.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.nombrar.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option cursor-pointer">
                                        <label :for="`check${formulario_mental.nombrar.test.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${formulario_mental.nombrar.test.ask}`" class="check" name="check" type="checkbox" v-model="formulario_mental.nombrar.test.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="formulario_mental.nombrar.test.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622  l140.894-140.898l31.309,31.309L174.199,322.918z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Repetición</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.repeticion.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.repeticion.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.repeticion.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option cursor-pointer">
                                        <label :for="`check${formulario_mental.repeticion.test.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${formulario_mental.repeticion.test.ask}`" class="check" name="check" type="checkbox" v-model="formulario_mental.repeticion.test.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="formulario_mental.repeticion.test.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622  l140.894-140.898l31.309,31.309L174.199,322.918z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Lectura</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.lectura.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.lectura.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.lectura.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option">
                                        <label :for="`check${formulario_mental.lectura.test.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${formulario_mental.lectura.test.ask}`" class="check" name="check" type="checkbox" v-model="formulario_mental.lectura.test.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="formulario_mental.lectura.test.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622  l140.894-140.898l31.309,31.309L174.199,322.918z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Comprensión</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.comprension.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.comprension.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.comprension.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option">
                                        <label :for="`check${formulario_mental.comprension.test.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${formulario_mental.comprension.test.ask}`" class="check" name="check" type="checkbox" v-model="formulario_mental.comprension.test.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="formulario_mental.comprension.test.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622  l140.894-140.898l31.309,31.309L174.199,322.918z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Escritura</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.escritura.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.escritura.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.escritura.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td>
                                    <div class="center-option">
                                        <label :for="`check${formulario_mental.escritura.test.ask}`" title="Marcar proceso como listo" class="cursor-pointer">

                                            <input :id="`check${formulario_mental.escritura.test.ask}`" class="check" name="check" type="checkbox" v-model="formulario_mental.escritura.test.check" @change="saveFormularioMental()"/>
                                            <svg  v-if="formulario_mental.escritura.test.check" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">
                                        <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622  l140.894-140.898l31.309,31.309L174.199,322.918z"/>
                                        </svg>
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" width="64px" height="64px" viewBox="0 0 64 64" version="1.1">
                                                <defs/>
                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
                                                    <circle id="Circle" stroke="#6B6C6E" stroke-width="2" sketch:type="MSShapeGroup" cx="32" cy="32" r="31"/>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                              <td colspan="2"><span class="text-primary">*Diseño</span></td>
                            </tr>
                            <tr class="inputGroup bgtr" :class="handleCheckStyle(formulario_mental.disenio.test)">
                                <td>
                                  <div class="mb-2">
                                    {{ formulario_mental.disenio.test.ask }}
                                  </div>
                                    <div class="form-group" title="Test de mental">
                                      <input type="text" class="form-control w-50" v-model="formulario_mental.disenio.test.detailValue" @change="saveFormularioMental" placeholder="Ingrese la respuesta..."/>
                                    </div>
                                </td>
                               
                                <td class="center-option">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="`check${formulario_mental.disenio.test.ask}`" v-model="formulario_mental.disenio.test.value">
                                        <label :for="`check${formulario_mental.disenio.test.ask}`" class="cursor-pointer">&nbsp;</label>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
        </div>
      </div>
      <div class="text-end fw-bold p-2 bg-light border-top mt-3 mb-4">
        Puntuación Total: {{ fm_TotalScore }}
      </div>
  </box>
  <box  title="Índice de Barthel (AVD)." icon="fa-solid fa-person-cane" :contraction='true'>
    <section class="row w-100">
        <div class=" d-flex flex-column col-12" ><small  
        :class="
        (ib_TotalScore<20) ? 'text-danger'
        :(ib_TotalScore>=20 && ib_TotalScore<35) ? 'text-warning'
        :(ib_TotalScore>=35 && ib_TotalScore<55) ? 'text-muted'
        :(ib_TotalScore>=55 && ib_TotalScore<85) ? 'text-success'
        :(ib_TotalScore===85) ? 'text-primary' : ''
        ">Grado de dependecia: 
        <span>
            {{ (ib_TotalScore<20) ? 'Total' : '' }}
            {{ (ib_TotalScore>=20 && ib_TotalScore< 35) ? 'Grave' : '' }}
            {{ (ib_TotalScore>=35 && ib_TotalScore< 55) ? 'Moderado' : '' }}
            {{ (ib_TotalScore>=55 && ib_TotalScore< 85) ? 'Leve' : '' }}
            {{ (ib_TotalScore===85) ? 'Independiente' : '' }}
        </span>
        </small></div>
        <div v-for="item in indice_barthel" :key="item.label" class="form-group col-12 col-md-4 row-gap-5 ">
         <div class="p-2">
            <label for="formControlRange" class="d-flex justify-content-between text-primary"><h6>{{ item.label }}</h6> <p>{{ item.score }}</p></label>
            <input v-if="item.type==='sm'" v-model="item.score" type="range" min="0" max="5" step="5" class="form-control-range cursor-pointer" id="formControlRange" aria-describedby="label" @change="saveBarthel">
            <input v-if="item.type==='md'" v-model="item.score" type="range" min="0" max="10" step="5" class="form-control-range cursor-pointer" id="formControlRange" aria-describedby="label" @change="saveBarthel">
            <input v-if="item.type==='lg'" v-model="item.score" type="range" min="0" max="15" step="5" class="form-control-range cursor-pointer" id="formControlRange" aria-describedby="label" @change="saveBarthel">
         </div>
         <small v-if="item.type==='sm'" id="label" class="form-text" :class="
          item.score==0 && 'text-danger'||
          item.score==5 && 'text-primary'
          ">
            {{(item.score==0) ? '0 - ' + item.description1 :''}}
            {{(item.score==5) ? '5 - ' + item.description2 : ''}}
          </small>
         <small v-if="item.type==='md'" id="label" class="form-text" :class="
          item.score==0 && 'text-danger' ||
          item.score==5 && 'text-success' ||
          item.score==10 && 'text-primary'
          ">
          {{(item.score==0) ? '0 - ' + item.description1: ''}}
          {{(item.score==5) ? '5 - ' + item.description2: ''}}
          {{(item.score==10) ? '10 - ' + item.description3: ''}}
          </small>
         <small v-if="item.type==='lg'" id="label" class="form-text" :class="
          item.score==0 && 'text-danger' ||
          item.score==5 && 'text-warning' ||
          item.score==10 && 'text-success'||
          item.score==15 && 'text-primary' 
          ">
          {{(item.score==0) ? '0 - ' + item.description1: ''}}
          {{(item.score==5) ? '5 - ' + item.description2: ''}}
          {{(item.score==10) ? '10 - ' + item.description3: ''}}
          {{(item.score==15) ? '15 - ' + item.description4: ''}}
          </small>
        </div>
      </section>
      <div class="text-end fw-bold p-2 bg-light border-top mt-3 mb-4">
        Puntuación Total: {{ ib_TotalScore }}
      </div>
  </box>
  <box  title="Índice de Lawton y Brody" icon="fa-solid fa-person-cane" :contraction='true'>
    <div class="row">
        <div class=" d-flex flex-column col-12" ><small  
        :class="
        (lb_TotalScore===0) ? 'text-muted'
        :(lb_TotalScore<=8) ? 'text-primary'
        :(lb_TotalScore> 8 && lb_TotalScore <= 20) ? 'text-warning'
        :(lb_TotalScore > 20) ? 'text-danger' : ''
        ">Grado de dependecia: 
        <span>
            {{ (lb_TotalScore===0) ? 'Seleccione opciones validas para el test' : '' }}
            {{ (lb_TotalScore<=8 && lb_TotalScore > 0) ? 'Independiente' : '' }}
            {{ (lb_TotalScore> 8 && lb_TotalScore <= 20) ? 'Necesita cierta ayuda' : '' }}
            {{ (lb_TotalScore > 20) ? 'Necesita mucha ayuda' : '' }}
        </span>
        </small>
    </div>
        <div class="col-12 col-sm-6 col-md-3" v-for="(item,key) in lawton_brody" :key="key" :class="item.type=== 'textarea' ? 'col-md-12': ''">
            <div class="form-group" v-if="item.type!=='textarea'">
                <label>{{item.name}}</label>
                <select class="form-control" v-model="item.score" @change="saveLawtonbrody">
                    <option v-for="(e,key) in item.options" :value="e.value" :key="key">
                      {{ e.option }} {{ e.value > 0 ? '(' + e.value + ')' : '' }}
                    </option>     
                </select>
            </div>
            <div class="form-group mb-2" v-else>
                <label>Comentarios del examinador</label>
                <textarea v-model="item.content" class="form-control" placeholder="Escriba comentarios aquí" @change="saveLawtonbrody"></textarea>
            </div>
        </div>
    </div>
    <div class="text-end fw-bold p-2 bg-light border-top mt-3 mb-4">
      Puntuación Total: {{ lb_TotalScore }}
    </div>
  </box>
  <box  title="Evaluación de dolor" icon="fa-solid fa-person-cane" :contraction='true'>
    <div class="row">
        <div class="col-12 col-sm-6 col-md-3" v-for="(item,key) in evaluacion_dolor.primary_question" :key="key">
            <div class="form-group" v-if="item.type==='select'">
                <label>{{item.label}}</label>
                <select class="form-control" v-model="item.value" @change="saveEvaluacionDolor">
                    <option v-for="(e,key) in item.options" :value="e.value" :key="key">{{ e.option }}</option>     
                </select>
            </div>
            <div class="form-group mb-2" v-if="item.type==='textarea'">
                <label>{{ item.label }}</label>
                <textarea v-model="item.value" class="form-control" placeholder="Escriba comentarios aquí" @change="saveEvaluacionDolor"></textarea>
            </div>
            <div class="form-group mb-2" v-if="item.type==='text'">
                <label>{{ item.label }}</label>
                <input v-model="item.value" class="form-control" placeholder="Escriba aquí" @change="saveEvaluacionDolor" type="text">
            </div>
        </div>
    </div>
    <div class=" d-flex flex-column col-12 mt-4" >
        <h6 class="text-primary">{{evaluacion_dolor.escala_visual_simple.label}}</h6>
        <small v-if="!evaluacion_dolor.escala_visual_simple.value"  class="text-danger">Seleccione una opción de la escala visual simple*</small>
        <div class="col-12 row m-4 mx-md-10 ">
            <div v-for="(item, index) in evaluacion_dolor.escala_visual_simple.options" :key="'simple-'+index" class="col-4 col-sm-2" title="seleccionar">
                <div class="minicard d-flex justify-content-center align-items-center cursor-pointer text-center" @click="evaluacion_dolor.escala_visual_simple.value = item.option ; saveEvaluacionDolor()" :class="(evaluacion_dolor.escala_visual_simple.value===item.option) ? 'bg-primary text-white': ''">
                    {{item.option}}
                </div>
            </div>
        </div>
    </div>
    <div class=" d-flex flex-column col-12 mt-4" >
        <h6 class="text-primary">{{evaluacion_dolor.escala_visual_numerica.label}}</h6>
        <small v-if="!evaluacion_dolor.escala_visual_numerica.value" class="text-danger">Seleccione una opción de la escala visual simple numérica*</small>
        <div class="col-12 row m-4 mx-md-10 ">
            <div v-for="(item, index) in evaluacion_dolor.escala_visual_numerica.options" :key="'numeric-'+index" class="col-1" title="seleccionar">
                <div class="minicard d-flex justify-content-center align-items-center cursor-pointer text-center p-2" @click="evaluacion_dolor.escala_visual_numerica.value = item.option ; saveEvaluacionDolor()" :class="(evaluacion_dolor.escala_visual_numerica.value===item.option)? 'bg-primary text-white': ''">
                    {{item.option}}
                </div>
            </div>
            <div class="col-12 d-flex justify-content-between aling-items-center px-2">
            <small class="text-success">Sin dolor*</small>
            <small class="text-danger mr-sm-8">Peor dolor imaginable*</small>
        </div>
        </div>
    </div>
    <div class=" d-flex flex-column col-12 mt-4" >
        <h6 class="text-primary">{{evaluacion_dolor.escala_visual_grafica.label}}</h6>
        <small v-if="!evaluacion_dolor.escala_visual_grafica.value" class="text-danger">Seleccione una opción de la escala visual grafica*</small>
        <div class="col-12 row m-4 mx-md-10 ">
            <div v-for="(item, index) in evaluacion_dolor.escala_visual_grafica.options" :key="'graphic-'+index" class="col-2" title="seleccionar">
                <div class="minicard d-flex justify-content-center align-items-center cursor-pointer text-center p-2" @click="evaluacion_dolor.escala_visual_grafica.value = item.option; saveEvaluacionDolor()" :class="(evaluacion_dolor.escala_visual_grafica.value===item.option)? 'bg-primary text-white': ''">
                   <i :class="item.icon" class="text-2xl"></i>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-between aling-items-center px-2">
            <small class="text-succes">Sin dolor*</small>
            <small class="text-danger">Peor dolor imaginable*</small>
        </div>
        </div>
    </div>
    <div class=" d-flex flex-column col-12 mt-4" >
        <h6 class="text-primary">Comentarios del examinador</h6>
        <textarea v-model="evaluacion_dolor.comentarios.value" class="form-control w-100" placeholder="Escribe aquí" @change="saveEvaluacionDolor"></textarea>
    </div>
  </box>
  <box  title="Evaluación postural" icon="fa-solid fa-person-cane" :contraction='true'>
    <div class="row mx-2">
        <div v-for="(item, key) in evaluacion_postural" :key="key" class="col-12">
            <div class="form-group mb-2 w-100">
                <label>{{item.label}}</label>
                <textarea v-model="item.value" class="form-control w-100" placeholder="Escribe aquí" @change="saveEvaluacionPostural"></textarea>
            </div>
        </div>
    </div>
  </box>
  <box  title="Escala de depresión geriatrica" icon="fa-solid fa-person-cane" :contraction='true'>
    <div class="d-flex align-items-center justify-content-center w-100 p-4">
        <div class="form-group w-100">
            <table class="table">
                        <thead class="thead-light">
                        <tr>
                            <th scope="col" class="font-weight-bold">
                                Pregunta
                            </th>
                            <th scope="col" class="font-weight-bold text-center">
                                Respuesta
                            </th>
                        </tr>
                        </thead>
                        <tbody class="table-hover">
                        <!-- Use new depre_geriatrica structure with radio buttons -->
                        <tr v-for="(item, key) in depre_geriatrica" :key="key" class="inputGroup bgtr" :class="handleCheckStyle2(item)">
                            <td>{{ item.label }}</td>
                            <td class="text-center">
                                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                    <label class="btn btn-outline-primary btn-sm" :class="{ 'active': item.answer === 'Sí' }">
                                        <input type="radio" :name="key" value="Sí" v-model="item.answer" @change="saveDepreGeriatrica"> Sí
                                    </label>
                                    <label class="btn btn-outline-secondary btn-sm" :class="{ 'active': item.answer === 'No' }">
                                        <input type="radio" :name="key" value="No" v-model="item.answer" @change="saveDepreGeriatrica"> No
                                    </label>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
    </div>
    <div class="text-end fw-bold p-2 bg-light border-top mt-3 mb-4">
        Puntuación Total: {{ dp_TotalScore }}
    </div>
  </box>
  <box  title="Evaluación neuromusculoesqueletica" icon="fa-solid fa-person-cane" :contraction='true'>
    <div class="row">
        <h6 class=" col-12 text-primary mt-2 py-2">Examen Fisico</h6>
        <template  v-for="(item, key) in neuro_examen_fisico" :key="key">
            <div v-if="item.label!== 'Nivel de conciencia'" class="form-group col-12 col-sm-6">
                <label>{{ item.label }}</label>
                <input type="text" class="form-control" v-model="item.value" @change="saveNeuroExamenFisico"/>
            </div>
            <template v-else>
                <label class="py-2 col-12">
                    {{item.label}}
                </label>
                <div v-for="(option, index) in item.options" :key="key + '-' + index" class="col-12 col-sm-4 mb-2">
                    <label class="toggle">
                        <input class="toggle-checkbox" type="checkbox" v-model="option.value" :checked="option.value" @change="saveNeuroExamenFisico"/>
                        <div class="toggle-switch"></div>
                        <span class="toggle-label">
                            {{ option.option }}
                        </span>
                    </label>
                </div>
            </template>
           
        </template>
    </div>
    <div class="row">
        <h6 class=" col-12 text-primary mt-2 py-2">Inspección</h6>
        <template  v-for="(item, key) in inspeccion" :key="key" >
            <div class="form-group col-12 col-sm-4">
                <label>{{ item.label }}</label>
                <input type="text" class="form-control" v-model="item.value" @change="saveInspeccion"/>
            </div>
        </template>
    </div>
    <div class="d-flex justify-content-center align-content-center flex-column">
        <h6 class=" w-100 text-primary mt-2 py-2">Palpación</h6>
        <div class="w-100 p-4">
        <label>Sensibilidad</label>
        <table class="table w-100">
            <thead class="thead-light">
            <tr>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                        Sensibilidad Superficial
                    </div>
                </th>
                <th colspan="4" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Respuesta
                    </div>
                </th>
            </tr>    
            <tr>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                        Estimulo
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Normoestesia
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                        Hiperestesia
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Hipoetesia
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Disestesia
                    </div>
                </th>
            </tr>
            </thead>
            <tbody class="table-hover">
                <tr v-for="(item, key) in sensibilidad_superficial" :key="key">
                <th scope="col" class="font-weight-bold">
                    {{ item.label}}
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="item.normoestesia" @change="saveSensibilidad('sensibilidad_superficial')"/>
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="item.hiperestesia" @change="saveSensibilidad('sensibilidad_superficial')"/>
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="item.hipoetesia" @change="saveSensibilidad('sensibilidad_superficial')"/>
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="item.disestesia" @change="saveSensibilidad('sensibilidad_superficial')"/>
                    </div>
                </th>
            </tr>
            </tbody>
        </table>
        <table class="table w-100 mt-2">
            <thead class="thead-light">
            <tr>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                        Sensibilidad Profunda
                    </div>
                </th>
                <th colspan="4" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Respuesta
                    </div>
                </th>
            </tr>    
            <tr>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                        Estimulo
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Normoestesia
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                        Hiperestesia
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Hipoetesia
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Disestesia
                    </div>
                </th>
            </tr>
            </thead>
            <tbody class="table-hover">
                <tr v-for="(item, key) in sensibilidad_profunda" :key="key">
                <th scope="col" class="font-weight-bold">
                    {{ item.label}}
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="item.normoestesia" @change="saveSensibilidad('sensibilidad_profunda')"/>
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="item.hiperestesia" @change="saveSensibilidad('sensibilidad_profunda')"/>
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="item.hipoetesia" @change="saveSensibilidad('sensibilidad_profunda')"/>
                    </div>
                </th>
                <th scope="col" class="font-weight-bold">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="item.disestesia" @change="saveSensibilidad('sensibilidad_profunda')"/>
                    </div>
                </th>
            </tr>
            </tbody>
        </table>
        <table class="table w-100 mt-2">
            <thead class="thead-light">
            <tr>
                <th scope="col" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                        Sensibilidad cortical
                    </div>
                </th>
                <th colspan="4" class="font-weight-bold">
                    <div class="d-flex justify-content-center">
                    Hallazgo
                    </div>
                </th>
            </tr>    
            </thead>
            <tbody class="table-hover">
                <tr v-for="(item, key) in sensibilidad_cortical" :key="key">
                    <th scope="col" class="font-weight-bold">
                        {{ item.label}}
                    </th>
                    <th scope="col" class="font-weight-bold">
                        <div class="form-group">
                            <input type="text" class="form-control" v-model="item.value" @change="saveSensibilidad('sensibilidad_cortical')"/>
                        </div>
                    </th>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="mt-2 w-100 p-4">
        <label>Tono Muscular</label>
        <div class="row">
            <div v-for="(item, key) in tono_muscular" :key="key" class="col-12">
                <div class="form-group mb-2">
                    <label>{{ item.label }}</label>
                    <textarea v-model="item.value" class="form-control" placeholder="Escribe aquí" @change="saveTonoMuscular"></textarea>
                </div>
            </div>
         </div>
    </div>

    <div class="mt-2 w-100 p-4">
        <label>Reflejos Osteotendinosos</label>
        <table class="table w-100 mt-2">
            <thead class="thead-light">
            <tr>
                <th scope="col" class="font-weight-bold">
                    Reflejo
                </th>
                <th scope="col" class="font-weight-bold">
                    Segmento Espinal
                </th>
                <th scope="col" class="font-weight-bold">
                    Lado
                </th>
                <th scope="col" class="font-weight-bold">
                    Respuesta
                </th>
                <th scope="col" class="font-weight-bold">
                    Observaciones
                </th>
            </tr>    
            </thead>
            <tbody class="table-hover">
                <tr v-for="(item, index) in reflejos" :key="index">
                    <td>
                        {{ item.nombre }}
                    </td>
                    <td>
                        <input type="text" class="form-control" v-model="item.segmento" @change="saveReflejo" placeholder="Segmento"/>
                    </td>
                    <td>
                        <select class="form-control" v-model="item.lado" @change="saveReflejo">
                            <option value="Izquierdo">Izquierdo</option>
                            <option value="Derecho">Derecho</option>
                        </select>
                    </td>
                    <td>
                        <input type="text" class="form-control" v-model="item.respuesta" @change="saveReflejo" placeholder="Respuesta"/>
                    </td>
                    <td>
                        <input type="text" class="form-control" v-model="item.observaciones" @change="saveReflejo" placeholder="Opcional"/>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-100 mt-2 p-4">
        <label>Sensación Final</label>

        <div v-if="typeof GetMedicoFichaActive.metadata.sensacion_final === 'undefined'" class="w-100">
            <div class="text-center text-danger">No tiene sensaciones finales ingresadas</div>
        </div>
        <div v-else class="w-100">
            <table class="table align-middle m-0">
                <thead class="small flex-sm-nowrap font-weight-bold">
                    <tr class="font-weight-bold small">
                        <th class="font-weight-bold">Miembro o segmento a evaluar</th>
                        <th class="font-weight-bold">Tipo de sensacion final</th>
                        <th class="font-weight-bold">Dolor (Si o No)</th>
                    </tr>
                </thead>
                <tbody class="small">
                    <template v-for="item in GetMedicoFichaActive.metadata.sensacion_final" :key="item.id">
                    <tr v-if="(typeof item.detail) !== 'undefined'" >
                        <td>{{ item.detail.miembro_segmento }}</td>
                        <td>{{ item.detail.tipo_sensacion }}</td>
                        <td>{{ item.detail.dolor }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div v-if="showEditionSensacion || showAddSensacion" class="row mt-2">
            <h6 class="text-primary col-12">
                {{showAddSensacion ? " Agregar sensación final" : "Editar sensación final"}}
            </h6>
           
            <div class="form-group col-3">
                    <label>Miembro o segmento nuevo</label>
                    <input type="text" class="form-control" v-model="sensacion_final.detail.miembro_segmento"/>
            </div>
            <div class="form-group col-3">
                    <label>Tipo de sensación final</label>
                    <input type="text" class="form-control" v-model="sensacion_final.detail.tipo_sensacion"/>
            </div>
            <div class="form-group col-3">
                    <label>Dolor (Si o No)</label>
                    <input type="text" class="form-control" v-model="sensacion_final.detail.dolor"/>
            </div>
            <div class="col-3 d-flex justify-content-around align-items-center">
                <button class="btn btn-danger" type="buttom" @click="cancelAddOrEditSensaFinal">
                    Cancelar
                </button>
                <button class="btn btn-primary" type="buttom" @click="saveSensacionFinal">
                    Guardar
                </button>
            </div>
        </div>
        <div v-else class="mt-4 text-right">
            <button class="btn btn-primary" @click="newSensacionFinal">
                <i class="fa fa-plus mr-2"></i>Agregar nueva sensación final
            </button>
        </div>

    </div>

    <div class="w-100 mt-2 p-4">
        <label>Fuerza Muscular</label>

        <div v-if="typeof GetMedicoFichaActive.metadata.fuerza_muscular === 'undefined'" class="w-100">
            <div class="text-center text-danger">No tiene fuerza muscular ingresada</div>
        </div>
        <div v-else class="w-100">
            <table class="table align-middle m-0">
                <thead class="small flex-sm-nowrap font-weight-bold">
                    <tr class="font-weight-bold small">
                        <th class="font-weight-bold">Miembro o segmento a evaluar</th>
                        <th class="font-weight-bold">Músculo</th>
                        <th class="font-weight-bold">Grado de fuerza muscular (0-5) Segun escala de valoración</th>
                    </tr>
                </thead>
                <tbody class="small">
                    <template v-for="item in GetMedicoFichaActive.metadata.fuerza_muscular" :key="item.id">
                    <tr v-if="(typeof item.detail) !== 'undefined'" >
                        <td>{{ item.detail.miembro_segmento }}</td>
                        <td>{{ item.detail.musculo }}</td>
                        <td>{{ item.detail.fuerza }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div v-if="showEditionFuerzaM || showAddFuerzaM" class="row mt-2">
            <h6 class="text-primary col-12">
                {{showAddFuerzaM ? " Agregar sensación final" : "Editar sensación final"}}
            </h6>
           
            <div class="form-group col-3">
                    <label>Miembro o segmento nuevo</label>
                    <input type="text" class="form-control" v-model="fuerza_muscular.detail.miembro_segmento"/>
            </div>
            <div class="form-group col-3">
                    <label>Músculo</label>
                    <input type="text" class="form-control" v-model="fuerza_muscular.detail.musculo"/>
            </div>
            <div class="form-group col-3" title="Segun escala de valoración">
                    <label>Grado de fuerza muscular (0-5)</label>
                    <input type="number" class="form-control" v-model="fuerza_muscular.detail.fuerza"/>
            </div>
            <div class="col-3 d-flex justify-content-around align-items-center">
                <button class="btn btn-danger" type="buttom" @click="cancelAddOrEditFuerzaM">
                    Cancelar
                </button>
                <button class="btn btn-primary" type="buttom" @click="saveFuerzaM">
                    Guardar
                </button>
            </div>
        </div>
        <div v-else class="mt-4 text-right">
            <button class="btn btn-primary" @click="newFuerzaM">
                <i class="fa fa-plus mr-2"></i>Agregar nueva fuerza muscular
            </button>
        </div>

    </div>

    <div class="w-100 mt-2 p-4">
        <label>Pruebas Especiales</label>

        <div v-if="typeof GetMedicoFichaActive.metadata.pruebas_especiales === 'undefined'" class="w-100">
            <div class="text-center text-danger">No tiene pruebas especiales</div>
        </div>
        <div v-else class="w-100">
            <table class="table align-middle m-0">
                <thead class="small flex-sm-nowrap font-weight-bold">
                    <tr class="font-weight-bold small">
                        <th class="font-weight-bold">Miembro o segmento a evaluar</th>
                        <th class="font-weight-bold">Prueba</th>
                        <th class="font-weight-bold">Hallazgo</th>
                    </tr>
                </thead>
                <tbody class="small">
                    <template v-for="item in GetMedicoFichaActive.metadata.pruebas_especiales" :key="item.id">
                    <tr v-if="(typeof item.detail) !== 'undefined'" >
                        <td>{{ item.detail.miembro_segmento }}</td>
                        <td>{{ item.detail.prueba }}</td>
                        <td>{{ item.detail.hallazgo }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div v-if="showEditionPruebaEspecial || showAddPruebaEspecial" class="row mt-2">
            <h6 class="text-primary col-12">
                {{showAddPruebaEspecial ? " Agregar sensación final" : "Editar sensación final"}}
            </h6>
           
            <div class="form-group col-3">
                    <label>Miembro o segmento nuevo</label>
                    <input type="text" class="form-control" v-model="pruebas_especiales.detail.miembro_segmento"/>
            </div>
            <div class="form-group col-3">
                    <label>Prueba</label>
                    <input type="text" class="form-control" v-model="pruebas_especiales.detail.prueba"/>
            </div>
            <div class="form-group col-3" title="Segun escala de valoración">
                    <label>Hallazgo</label>
                    <input type="text" class="form-control" v-model="pruebas_especiales.detail.hallazgo"/>
            </div>
            <div class="col-3 d-flex justify-content-around align-items-center">
                <button class="btn btn-danger" type="buttom" @click="cancelAddOrEditPruebaEspecial">
                    Cancelar
                </button>
                <button class="btn btn-primary" type="buttom" @click="savePruebaEspecial">
                    Guardar
                </button>
            </div>
        </div>
        <div v-else class="mt-4 text-right">
            <button class="btn btn-primary" @click="newPruebaEspecial">
                <i class="fa fa-plus mr-2"></i>Agregar nueva prueba especial
            </button>
        </div>

    </div>

    </div> 
</box>
<Box title="Rangos Articulares (ROM)" icon="fa-solid fa-person-walking" :contraction="true">
    <!-- Add/Edit Form -->
    <div v-if="showAddRango || showEditionRango" class="mt-3 mb-4 p-3 border rounded bg-light">
        <div>
            <h5>{{ showAddRango ? 'Agregar' : 'Editar' }} Rango Articular</h5>
        </div>
        <!-- Hidden input for ID if needed, though editingRango.id holds it -->
        <input type="hidden" v-model="editingRango.id">
        <div class="row">
            <div class="col-12 col-md-3">
                <div class="form-group">
                    <label>Articulación</label>
                    <select class="form-control" v-model="editingRango.detail.articulacion">
                        <option value="" disabled>Seleccione articulación</option>
                        <option v-for="option in articulaciones_options" :key="option" :value="option">{{ option }}</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-3">
                <div class="form-group">
                    <label>Movimiento</label>
                    <select class="form-control" v-model="editingRango.detail.movimiento" :disabled="!editingRango.detail.articulacion">
                        <option value="" disabled>Seleccione movimiento</option>
                        <option v-for="option in getMovimientoOptions(editingRango.detail.articulacion)" :key="option" :value="option">{{ option }}</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-2">
                <div class="form-group">
                    <label>Lado</label>
                    <select class="form-control" v-model="editingRango.detail.lado">
                        <option v-for="option in lado_options" :key="option" :value="option">{{ option }}</option>
                    </select>
                </div>
            </div>
            <div class="col-12 col-md-2">
                <div class="form-group">
                    <label>R. Activo (°)</label>
                    <input type="number" class="form-control" v-model="editingRango.detail.rango_activo">
                </div>
            </div>
            <div class="col-12 col-md-2">
                <div class="form-group">
                    <label>R. Pasivo (°)</label>
                    <input type="number" class="form-control" v-model="editingRango.detail.rango_pasivo">
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label>Hallazgos</label>
                    <input type="text" class="form-control" v-model="editingRango.detail.hallazgos">
                </div>
            </div>
        </div>
        <div class="text-right mt-3">
            <button @click="cancelEditRango" class="btn btn-secondary mr-2">Cancelar</button>
            <button @click="saveRango" class="btn btn-primary">Guardar</button>
        </div>
    </div>

    <!-- Display Table -->
    <div v-if="typeof GetMedicoFichaActive.metadata.rangos_articulares === 'undefined' || GetMedicoFichaActive.metadata.rangos_articulares.length === 0">
        <div class="text-center text-muted p-3">
            <i class="fas fa-info-circle mr-2"></i>No hay rangos articulares registrados.
        </div>
    </div>
    <div v-else class="table-responsive">
        <table class="table table-sm table-bordered table-hover">
            <!-- Table Header -->
            <thead class="thead-light">
                <tr>
                    <th style="width: 15%;">Articulación</th>
                    <th style="width: 15%;">Movimiento</th>
                    <th style="width: 10%;">Lado</th>
                    <th style="width: 10%;">R. Activo (°)</th>
                    <th style="width: 10%;">R. Pasivo (°)</th>
                    <th style="width: 10%;" class="text-center">R. Normal</th>
                    <th style="width: 20%;">Hallazgos</th>
                    <th style="width: 10%;" class="text-center">Acciones</th>
                </tr>
            </thead>
            <!-- Table Body -->
            <tbody>
                <tr v-for="(item, index) in GetMedicoFichaActive.metadata.rangos_articulares" :key="item.id || index">
                    <template v-if="item.detail"> <!-- Ensure detail exists -->
                        <td>{{ item.detail.articulacion }}</td>
                        <td>{{ item.detail.movimiento }}</td>
                        <td>{{ item.detail.lado }}</td>
                        <td>{{ item.detail.rango_activo }}</td>
                        <td>{{ item.detail.rango_pasivo }}</td>
                        <td class="text-center">{{ getNormalRom(item.detail.articulacion, item.detail.movimiento) }}</td>
                        <td>{{ item.detail.hallazgos }}</td>
                        <td class="text-center">
                            <i @click="editRango(item)" class="fas fa-edit text-primary cursor-pointer mr-3" title="Editar"></i>
                            <i @click="deleteRango(item)" class="fas fa-trash text-danger cursor-pointer" title="Eliminar"></i>
                        </td>
                    </template>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Add Button (shown when form is hidden) -->
    <div v-if="!showAddRango && !showEditionRango" class="mt-4 text-right">
        <button class="btn btn-primary" @click="addRango">
            <i class="fa fa-plus mr-2"></i>Agregar nuevo rango articular
        </button>
    </div>
</Box>
<box  title="Patrones Capsulares" icon="fa-solid fa-table" :contraction='true'>
    <div class="box-container">
      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="sticky-top">
            <tr>
              <th style="width: 20%">Articulación</th>
              <th>Patrón Capsular</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(patron, index) in patrones_capsulares" :key="index">
              <td class="align-middle">{{ patron.articulacion }}</td>
              <td>
                <textarea 
                  class="form-control" 
                  v-model="patron.patron" 
                  rows="2"
                  @change="savePatronesCapsulares"
                  placeholder="Describa el patrón capsular..."
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</box>
<box  title="Concluciones" icon="fa-solid fa-clipboard-user" :contraction='true'>
<div class="row mx-2">
    <div class="col-12">
        <div class="form-group mb-2">
            <label>Analisis Clinicofuncional Fisioterapeutico</label>
            <textarea v-model="concluciones_g.ac_fisioterapeutico" class="form-control" placeholder="Escribe aquí" @change="saveConcluciones"></textarea>
        </div>
    </div>
    <div class="col-12">
        <div class="form-group mb-2">
            <label>Historia psiquiatrica</label>
            <textarea v-model="concluciones_g.conclucion_tratamiento" class="form-control" placeholder="Escribe aquí" @change="saveConcluciones"></textarea>
        </div>
    </div>
    </div>

</box>
</template>
 
 
<style scoped>
.bgtr{
    background-color: var(--bodyBackground);
    transition: 0.2s ease-in;
}

.bgtr td{
    background-color: transparent;
}
.center-option{
   display: flex; 
   flex-direction: row;
   justify-content: center;
   padding: 5px 20px;
}

.check-style{
    color: white;
    background-color: #007bff;
    .center-option label svg{
        border-radius: 50%;
        background-color: aliceblue;
        opacity: 1;
    }
}
.cancel-style{
    background-color: #6c6c6c27;
    opacity: 0.6;
    .center-option label svg{
        border-radius: 50%;
        background-color: aliceblue;
        opacity: 1;
    }
}

.minicard{
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border-radius:7px;
    width:80%;
    max-width:95%;
    height:80px;
}

.cancel,
.check {
    outline: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    order: 1;
    z-index: 1;
    cursor: pointer;
    visibility: hidden;
}

.center-option label {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  width: 30px;
  height: 30px;
}


.center-option label svg{
    position: absolute;
    width: 25px;
    height: 25px;
}

.inputGroup {
    /* background-color: #fff;
    display: block;
    margin: 10px 0; */
    position: relative;
   
  }

  .text-detail{
    resize: none;
    max-height: 35px;
    text-decoration: none;
  }

.table th, .table td {
    vertical-align: middle; /* Align content vertically */
    font-size: 0.85rem; /* Slightly smaller font for table */
    padding: 0.4rem; /* Adjust padding */
}
.table thead th {
    background-color: #f8f9fa; /* Light grey background for header */
    font-weight: 500;
    position: sticky; /* Make header sticky */
    top: 0; /* Stick to the top */
    z-index: 1; /* Ensure header is above table body */
}
.form-select-sm, .form-control-sm {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    min-height: calc(1.5em + 0.5rem + 2px);
    font-size: 0.85rem; /* Match table font size */
}
.table-responsive {
    max-height: 400px; /* Limit table height and enable scrolling */
    overflow-y: auto;
}

.box-container {
    height: fit-content;
}



</style>